import script from "./PageHeaderApprovals.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeaderApprovals.vue?vue&type=script&lang=ts&setup=true"

import "./PageHeaderApprovals.vue?vue&type=style&index=0&id=ff4a7cc6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff4a7cc6"]])

export default __exports__